import type { FC } from "react";
import type { ObjPathProxy } from "ts-object-path";
import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import type { MyPlannResourceDictionary } from "web_myplann/Infrastructure/Translations/ResourceDictionary";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailRow } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailRow";

const PageResources = Resources.PortfolioDetail;

type Props = {
	baseData: PortfolioDetailResponseDTO;
	nameLabel?: ObjPathProxy<MyPlannResourceDictionary, string>;
};

export const PortfolioBasicInfoRows: FC<Props> = ({ baseData, nameLabel }) => {
	const { t } = useResource();

	return (
		<>
			<DetailRow
				label={t(nameLabel ?? PageResources.SharedLabels.name)}
				value={baseData.clientName}
			/>
			<DetailRow
				label={t(PageResources.SharedLabels.contractNumber)}
				value={baseData.contractNumber}
			/>
			<DetailRow
				label={t(PageResources.SharedLabels.producent)}
				value={baseData.producer}
			/>
			<DetailRow
				label={t(PageResources.SharedLabels.product)}
				value={baseData.product}
			/>
		</>
	);
};
